module.exports = __webpack_public_path__ + "img/15.1.3d32a8b3.jpg";